import { render, staticRenderFns } from "./PaymentPageSettings.vue?vue&type=template&id=0cdc1a98"
import script from "./PaymentPageSettings.vue?vue&type=script&lang=js"
export * from "./PaymentPageSettings.vue?vue&type=script&lang=js"
import style0 from "./PaymentPageSettings.vue?vue&type=style&index=0&id=0cdc1a98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports